import { useMemo } from 'react';

export const useDayDuration = (
  groupedDurations: Record<string, number>
): number => {
  return useMemo(() => {
    const groupDurations = Object.values(groupedDurations);
    if (groupDurations.length === 0) {
      return 0;
    }

    const duration = groupDurations.reduce(
      (prev: number, duration: number) => prev + duration,
      0
    );

    return duration;
  }, [groupedDurations]);
};
